"use client";

import { CollectionCards } from "@/composites/category";

import type { CollectionHighlightsContent } from "./read-collection-highlights";

export function CollectionHighlights({
	sections
}: {
	sections: CollectionHighlightsContent[];
}): JSX.Element | null {
	if (sections.length === 0) return null;

	return (
		<>
			{sections.map((section, index) => (
				<CollectionCards
					key={`${section.heading ?? "highlights"}-${index}`}
					heading={section.heading}
					cards={section.cards}
					variant={section.style}
					tinted={section.tinted}
					action={section.action}
				/>
			))}
		</>
	);
}
